export default __webpack_public_path__ + "155268b05af0bafb29553e74a4e7a7ae.woff2";